
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'service-selectAddress',
  templateUrl: '../../templates/partials/selectAddress-service.html'
})
export class SelectAddressServiceComponent{

    @Input() addresses: object;
    @Output() addressSelectedEmitter = new EventEmitter();
    public selected;

    constructor(){}

    public setAddress(address: object) {
        //console.log(address);
        this.selected = address["id_address"];
        this.addressSelectedEmitter.emit(address);
    }
    

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/selectAddress-service.component.ts